module.exports = __webpack_public_path__ + "img/add_w.52b40553.svg";